import Component from "../../../component";

export const CollectionInsertConfig = {
    signature: 'collectionInsert',
    baseHtmlClass: 'insert_item',
    selector: '.insert_item',
    initedHtmlClassModifier: 'inited'
};

export class CollectionInsert extends Component {

    static constructAll(elements) {
        let collectionInserts = [];
        elements.forEach((element) => {
            if (CollectionInsert.isElementComponentized(element, CollectionInsertConfig.signature)) return;
            collectionInserts.push(new CollectionInsert(element));
        });
        return collectionInserts;
    }

    constructor(id_or_element, props = {}) {
        super({
            element: id_or_element,
            config: CollectionInsertConfig
        });
    }

    getId() {
        return this.id;
    }
}
